import { gallerySectionProjSol } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import React, { useState } from "react";
// import Masonry from "react-masonry-component";
import GalleryItem from "./GalleryItem";
import { Box, ImageList } from "@mui/material";
import MansonryLoader from "components/MansonryLoader/MansonryLoader";
import { useAppStore } from "lib/store";

// console.log(gallerySectionProjSol);
const masonryOptions = {
  transitionDuration: 500,
};

const { title, tabBtns, items } = gallerySectionProjSol;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;

const GallerySectionProjSol = ({ portfolio = false, similar = false }) => {
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");
  const { loading, error, projectSolutions } = useAppStore();

  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            Our Work
            <span className="dot">.</span>
          </h2>
        </div>
        <div className="mixitup-gallery">
          <div className={portfolio || similar ? "" : "upper-row clearfix"}>
          <Box sx={{ width: '100%', height: 450, overflowY: 'scroll' }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {Array(projectSolutions.total).fill(0).slice(0, Array(projectSolutions.total).length).map((item, index) => (
                index != 0 && <MansonryLoader
                  key={`${projectSolutions.title}-${index}`}
                  title={projectSolutions.title}
                  count={index}
                  path={projectSolutions.path}
                  alt='Project-Solutions' />
              ))}
            </ImageList>
          </Box>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySectionProjSol;
